import React from 'react'
import {connect} from 'react-redux'
import Titulo from '../comum/Titulo';
import {getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import buscarAgencias from '../../actions/agencia/buscarAgencias';
import excluirAgencia from '../../actions/agencia/excluirAgencia';
import selecionarAgencia from '../../actions/agencia/selecionarAgencia';
import PaginacaoAgencia from './PaginacaoAgencia';
import BotoesPaginacaoAgencia from './BotoesPaginacaoAgencia';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PainelFiltragem from './PainelFiltrosAgencia';
import Agencia from './Agencia';
import ModalCadastrarAgencia from './ModalCadastrarAgencia';
import bloquearAgencia from '../../actions/agencia/bloquearAgencia';
import desbloquearAgencia from '../../actions/agencia/desbloquearAgencia';
import {showSuccessMsg} from '../../util/messagesUtil';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-tabela-dados">
        <div className="row cabecalho-desktop">
            <div className="col"></div>
            <div className="col">Número</div>
            <div className="col">Nome</div>
            <div className="col">Localidade</div>
            <div className="col">UF</div>
            <div className="col">Logradouro</div>
            <div className="col">Bairro</div>
            <div className="col">Cep</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

const ModalConfirmacaoBloqueioAgencia = ({bloquearDesbloquear, agencia}) => (
    <div className="modal fade" id="modalConfirmacaoBloqueioAgencia" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoBloqueioAgencia" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja {agencia && agencia.bloqueada ? 'desbloquear' : 'bloquear'} a
                        agência <strong>{agencia ? agencia.nome : ''}?</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => bloquearDesbloquear()}>Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoExclusao = ({excluir, agencia}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoAgencia" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir a agência <strong>{agencia ? agencia.nome : ''}?</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarAgencias extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parametros: {
                nome: '',
                uf: ''
            }
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.buscarAgencias();
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps) || this.props.empresaSelecionada !== prevProps.empresaSelecionada) {
            this.buscarAgencias();
        }
    }

    bloquearDesbloquear() {
        if (this.props.agenciaSelecionada.bloqueada) {
            this.props.desbloquearAgencia(this.props.agenciaSelecionada.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.props.buscarAgencias(this.props.empresaSelecionada.id);
                    }
                })
        } else {
            this.props.bloquearAgencia(this.props.agenciaSelecionada.id, this.props.empresaSelecionada.id)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.props.buscarAgencias(this.props.empresaSelecionada.id);
                    }
                })
        }

    }

    buscarAgencias() {
        this.props.buscarAgencias(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoNovoAgencia() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="text-right">
                        <button data-toggle="modal" data-target="#modalCadastrarAgencia" className="btn btn-laranja"
                                onClick={() => this.props.selecionarAgencia()}>
                            Nova Agência
                        </button>
                    </div>
                </div>
            </div>)
    }

    exibir() {
        if (this.props.agencias && this.props.agencias.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoAgencia}
                                       BotoesPaginacao={BotoesPaginacaoAgencia}>
                    <div className="col-12 conteudo-internas">
                        <CabecalhoTabela/>
                        <div className="lista-table">
                            {this.exibirAgencias()}
                        </div>
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhuma cidade encontrada para o parâmetro informados.</div>;
    }

    exibirAgencias() {
        if (this.props.agencias) {
            return this.props.agencias.map(agencia => <Agencia
                key={agencia.id} agencia={agencia} idEmpresa={this.props.empresaSelecionada.id}/>)
        }
    }

    excluir() {
        this.props.excluirAgencia(this.props.agenciaSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Agência excluída com sucesso');
                this.buscarAgencias();
            })
    }

    exibirFiltro() {
        return <div className="row">
            <div className="col-md-12">
                <div className="text-right">
                    <PainelFiltragem/>
                </div>
            </div>
        </div>
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Agências" urlRetorno="/"/>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            {this.exibirFiltro()}
                            {this.exibirBotaoNovoAgencia()}
                            <div className="lista-table">
                                {this.exibir()}
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCadastrarAgencia parametros={this.state.parametros}
                                       buscarAgencias={this.buscarAgencias.bind(this)}/>
                <ModalConfirmacaoExclusao excluir={this.excluir.bind(this)} agencia={this.props.agenciaSelecionada}/>
                <ModalConfirmacaoBloqueioAgencia bloquearDesbloquear={this.bloquearDesbloquear.bind(this)}
                                                 agencia={this.props.agenciaSelecionada}/>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => (
    {
        agencias: state.agencias.agencias,
        agenciaSelecionada: state.agencias.agenciaSelecionada,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualAgencia,
        registrosPorPagina: state.registrosPorPaginaAgencia,
        filtrosAdicionados: state.filtrosAdicionadosAgencia

    });


export default connect(mapStateToProps, {
    buscarAgencias,
    excluirAgencia,
    selecionarAgencia,
    desbloquearAgencia,
    bloquearAgencia
})(PainelGerenciarAgencias)
